module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_9005.dd0d0b5f.png";